export const fmt = {
  dollars: (v, decimals = 0) => {
    if (v == null) return '—';
    if (Math.abs(v) >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
    if (Math.abs(v) >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
    return `$${Number(v).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
  },
  pct: (v, decimals = 1) => {
    if (v == null) return '—';
    return `${(v * 100).toFixed(decimals)}%`;
  },
  pctRaw: (v, decimals = 1) => {
    // for values already in 0-100 scale
    if (v == null) return '—';
    return `${Number(v).toFixed(decimals)}%`;
  },
  num: (v, decimals = 0) => {
    if (v == null) return '—';
    return Number(v).toLocaleString('en-US', { maximumFractionDigits: decimals });
  },
  shortNum: (v) => {
    if (v == null) return '—';
    if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
    if (v >= 1e3) return `${(v / 1e3).toFixed(0)}K`;
    return String(v);
  },
  pbpm: (v) => {
    if (v == null) return '—';
    return `$${Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  },
};

export const COLORS = {
  navy:        '#1a3a52',
  teal:        '#42BA97',
  blue:        '#335B74',
  green:       '#2e7d4f',
  red:         '#c0392b',
  amber:       '#d4860a',
  purple:      '#6b4ca8',
  coral:       '#e07b54',
  slate:       '#5a7a94',
  lightBlue:   '#8bc4e0',
  gray:        '#adb5bd',
};

export const TRACK_COLORS = {
  'One-Sided':                    '#335B74',
  'Two-Sided (Track 2)':          '#d4860a',
  'Two-Sided (Basic C-E/T1+)':    '#42BA97',
  'Two-Sided (Enhanced/T3)':      '#2e7d4f',
  'Other':                        '#adb5bd',
};

export const YEARS = [2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024];

// Annotations for major program events
export const PROGRAM_EVENTS = {
  2016: 'Quality measures expanded',
  2018: 'Track 1+ introduced; SNF waiver',
  2019: 'Pathways to Success launch',
  2020: 'COVID-19',
  2021: 'CAHPS measures added; sliding-scale quality',
  2023: 'Record $2.1B net savings',
};

// ── Chart PNG export via SVG serialization ───────────────────────────────
// Finds the recharts SVG inside a card element and downloads it as PNG
export function exportChartPNG(cardEl, filename = 'chart') {
  if (!cardEl) return;
  const svg = cardEl.querySelector('svg.recharts-surface, svg');
  if (!svg) { alert('No chart found to export.'); return; }

  // Clone and add white background
  const clone = svg.cloneNode(true);
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  const bg = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  bg.setAttribute('width', '100%'); bg.setAttribute('height', '100%');
  bg.setAttribute('fill', 'white');
  clone.insertBefore(bg, clone.firstChild);

  const svgStr = new XMLSerializer().serializeToString(clone);
  const blob   = new Blob([svgStr], { type: 'image/svg+xml' });
  const url    = URL.createObjectURL(blob);

  // Draw onto canvas for PNG
  const img = new Image();
  img.onload = () => {
    const w = svg.clientWidth  || parseInt(svg.getAttribute('width'))  || 800;
    const h = svg.clientHeight || parseInt(svg.getAttribute('height')) || 400;
    const canvas = document.createElement('canvas');
    canvas.width  = w * 2; canvas.height = h * 2; // 2x for retina
    const ctx = canvas.getContext('2d');
    ctx.scale(2, 2);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);
    URL.revokeObjectURL(url);
    const link = document.createElement('a');
    link.download = `${filename}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  };
  img.src = url;
}
